// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 16) return "static/chunks/39209d7c-349e9fba02426ec8.js";
	if (chunkId === 5454) return "static/chunks/4f9d9cd8-970064bc0849adb1.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5600 ? "05f6971a" : chunkId) + "." + {"2297":"263c139de0bc1b51","5600":"75011592d2c54421","8489":"140bc9656d104129"}[chunkId] + ".js";
};